import React, { useState } from "react";
import { RiArrowUpSLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
//doc tool

import "./PlanDetailAccordion.css";

function PlanDetailAccordion({ data }) {
  const [show, setShow] = useState(false);
  const { answer, question, image } = data;
  return (
    <div className="accordionDiv">
      <div className="topAccordion">
        {image && <img src={image} alt={image} className="toolIMg" />}
        <h4 className="AccordionHeading AccordionHeading2" onClick={() => setShow(!show)}>
         {question}
        </h4>

        {!show && <IoIosArrowDown onClick={() => setShow(!show)} />}
        {show && <RiArrowUpSLine onClick={() => setShow(!show)} />}
      </div>
      {answer && show && (
        <div className="bottomAccrodion">
          <ul className="AccordionUL AccordionUL2">
            {answer &&
              answer.list.map((val, index) => {
                return <li key={index} >{val}</li>;
              })}
          </ul>
        </div>
      )}
    </div>
  );
}

export default PlanDetailAccordion;
